import { DateTime } from "luxon";
import qs from "qs";
import DateUtility from "./lib/dateUtility";
import FetchHelper from "./lib/fetchHelper";
import SwipeNavigation from "./lib/swipeNavigation";
import WeekPicker from "./lib/weekPicker";
import React from "react";
import { ReactRenderer } from "./lib/ReactRenderer";
import { BPShiftStatus } from "./lib/bpShiftStatus";
import { RoleLabel } from "./lib/shiftList";
import { scrollBehavior } from "./lib/motion";
/**
 * The Vagtplan (boards Vagtplan, VagtplanUge and their Bred versions): the shifts of one week.
 * A phone gets a strip of the seven days and the shifts under the day they are on; from 992px
 * the week is seven columns side by side.
 */
const RsvpDot = ({ rsvp }) => {
    const title = rsvp === 1 ? "Kommer" : rsvp === 2 ? "Kommer ikke" : "Ikke svaret";
    const kind = rsvp === 1 ? "yes" : rsvp === 2 ? "no" : "none";
    return React.createElement("span", { className: `bi-rsvp bi-rsvp-${kind}`, role: "img", "aria-label": title, title: title });
};
/** One person on the shift: the role as an icon, the answer to the RSVP for the kiosk, the name. */
const Person = ({ member, mine }) => {
    const isOperator = member.role === "Operator";
    const label = isOperator ? "Operatør" : "Kiosk";
    return (React.createElement("div", { className: `bi-vp-person${isOperator ? " bi-vp-person-op" : ""}${mine ? " bi-vp-person-me" : ""}` },
        React.createElement("span", { className: "bi-vp-person-role", role: "img", "aria-label": label, title: label },
            React.createElement(RoleLabel, { role: member.role, iconOnly: true })),
        isOperator ? React.createElement("span", { className: "bi-vp-person-slot" }) : React.createElement(RsvpDot, { rsvp: member.rsvp }),
        React.createElement("span", { className: "bi-vp-person-name" }, member.name)));
};
/** What a shift still lacks, in the colour of the yellow shifts. */
const Missing = ({ role, text }) => (React.createElement("div", { className: "bi-vp-person bi-vp-person-missing" },
    React.createElement("span", { className: "bi-vp-person-role" },
        React.createElement(RoleLabel, { role: role, iconOnly: true })),
    React.createElement("span", { className: "bi-vp-person-slot" }),
    React.createElement("span", { className: "bi-vp-person-name" }, text)));
const ShiftCard = ({ shift, memberUdi, now }) => {
    var _a, _b, _c;
    const start = DateUtility.parse(shift.startTime);
    const end = DateUtility.parse(shift.endTime);
    const past = end < now;
    const members = (_a = shift.members) !== null && _a !== void 0 ? _a : [];
    const mine = members.some((m) => m.memberId === memberUdi);
    const urgent = !!shift.isRedShift && !past;
    const yellow = !!shift.isYellowShift && !past;
    const operator = members.find((m) => m.role === "Operator");
    const shops = members.filter((m) => m.role !== "Operator");
    const filledShops = shops.filter((m) => !m.isGhost).sort((a, b) => { var _a, _b; return ((_a = a.name) !== null && _a !== void 0 ? _a : "").localeCompare((_b = b.name) !== null && _b !== void 0 ? _b : "", "da"); });
    const openShops = shops.length - filledShops.length;
    let status;
    if (past) {
        status = null;
    }
    else if (urgent) {
        status = React.createElement("span", { className: "bi-chip bi-chip-urgent bi-chip-solid" },
            React.createElement("span", { className: "bi-sr-dot" }),
            "Haster");
    }
    else if (yellow) {
        status = React.createElement("span", { className: "bi-chip bi-chip-yellow" },
            React.createElement("span", { className: "bi-sr-dot bi-sr-dot-yellow" }),
            "Gul");
    }
    else {
        const planned = shift.status === BPShiftStatus.planned;
        status = (React.createElement("span", { className: `bi-chip ${planned ? "bi-chip-planned" : "bi-chip-preplanned"}` },
            React.createElement("span", { className: `bi-sr-dot ${planned ? "bi-sr-dot-planned" : "bi-sr-dot-preplanned"}` }),
            planned ? "Planlagt" : "Foreløbig"));
    }
    const classes = ["bi-vp-card"];
    if (urgent)
        classes.push("bi-vp-card-urgent");
    else if (yellow)
        classes.push("bi-vp-card-yellow");
    if (mine)
        classes.push("bi-vp-card-mine");
    if (past)
        classes.push("bi-vp-card-past");
    return (React.createElement("a", { className: classes.join(" "), href: `/vagtinfo/?shiftId=${shift.id}` },
        React.createElement("span", { className: "bi-vp-card-head" },
            React.createElement("span", { className: "bi-vp-time" }, DateUtility.rowInterval(start, end)),
            React.createElement("span", { className: "bi-vp-chips" },
                mine ? React.createElement("span", { className: "bi-chip bi-chip-role" }, "Din vagt") : null,
                status)),
        React.createElement("span", { className: "bi-vp-films" }, ((_c = (_b = shift.events) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 0
            ? shift.events.map((evt, idx) => {
                var _a, _b;
                return (React.createElement("span", { className: "bi-vp-film", key: idx },
                    React.createElement("span", { className: "bi-vp-film-time" }, DateUtility.parse(evt.startTime).toFormat("HH:mm")),
                    React.createElement("span", { className: "bi-vp-film-title" }, (_b = (_a = evt.eventContent) === null || _a === void 0 ? void 0 : _a.title) !== null && _b !== void 0 ? _b : evt.decoratedTitle)));
            })
            : React.createElement("span", { className: "bi-vp-film" },
                React.createElement("span", { className: "bi-vp-film-title" }, "Ingen planlagte film"))),
        React.createElement("span", { className: "bi-vp-crew" },
            operator
                ? (operator.isGhost
                    ? React.createElement(Missing, { role: "Operator", text: "Mangler operat\u00F8r" })
                    : React.createElement(Person, { member: operator, mine: operator.memberId === memberUdi }))
                : null,
            filledShops.map((m) => { var _a; return React.createElement(Person, { key: (_a = m.id) !== null && _a !== void 0 ? _a : m.memberId, member: m, mine: m.memberId === memberUdi }); }),
            openShops > 0 ? React.createElement(Missing, { role: "Shop", text: `Mangler ${openShops} kiosk` }) : null)));
};
/** The dot under a day of the strip: the most pressing thing about the day's shifts. */
const dayDot = (shifts, now) => {
    const open = shifts.filter((s) => DateUtility.parse(s.endTime) >= now);
    if (open.some((s) => s.isRedShift))
        return "urgent";
    if (open.some((s) => s.isYellowShift))
        return "yellow";
    if (shifts.some((s) => s.status === BPShiftStatus.preplanned))
        return "preplanned";
    return "planned";
};
export default class FullScheduleComponent extends React.Component {
    constructor(props) {
        super(props);
        this.swipeRef = React.createRef();
        this.navigating = false;
        // The week on screen stays until the one that was asked for has come, so picking a week does
        // not flash the page empty.
        this.selectWeek = (week) => {
            if (this.navigating)
                return;
            this.navigating = true;
            this.fetchSchedule(week)
                .then((loaded) => {
                this.showWeekInUrl(week);
                this.setState(loaded);
            })
                .catch((error) => console.error(error))
                .finally(() => { this.navigating = false; });
        };
        this.loadSchedule = (week) => {
            this.showWeekInUrl(week);
            this.fetchSchedule(week)
                .then((loaded) => this.setState(loaded))
                .catch((error) => {
                console.error(error);
            });
        };
        this.showWeekInUrl = (week) => {
            window.history.replaceState(null, null, qs.stringify({ dtStart: week.toFormat("yyyy-MM-dd") }, { addQueryPrefix: true }));
        };
        // Resolves to the state that shows the week, so the caller decides when it goes on screen.
        this.fetchSchedule = (week) => {
            const dt = week.toFormat("yyyy-MM-dd");
            return FetchHelper.get(`/bpapi/shiftschedule/week/${dt}`)
                .then((result) => {
                const days = Array.from({ length: 7 }, (_, i) => {
                    var _a;
                    const day = week.plus({ days: i }).toFormat("yyyy-MM-dd");
                    return (_a = result.find((d) => d.date === day)) !== null && _a !== void 0 ? _a : { date: day, shifts: [] };
                });
                return { isLoaded: true, schedule: days, week: week, firstLoad: false };
            });
        };
        const search = qs.parse(location.search, { ignoreQueryPrefix: true });
        let week = DateTime.now().startOf("week");
        if (search.dtStart) {
            const w = DateTime.fromFormat(search.dtStart, "yyyy-MM-dd");
            if (w.isValid) {
                week = w.startOf("week");
            }
        }
        this.state = {
            isLoaded: false,
            firstLoad: true,
            week: week,
            mineOnly: false
        };
    }
    componentDidMount() {
        this.loadSchedule(this.state.week);
    }
    componentDidUpdate(_prevProps, prevState) {
        if (this.state.schedule && this.state.schedule !== prevState.schedule) {
            this.scrollToToday();
        }
    }
    // On a phone the week is a long column. When it is this week, it opens on today (or on the
    // next day with shifts, when today has none), so the days that are over are above the fold.
    scrollToToday() {
        if (!window.matchMedia("(max-width: 991.98px)").matches)
            return;
        const week = this.state.week;
        const today = DateTime.now().startOf("day");
        if (today < week || today >= week.plus({ days: 7 }))
            return;
        const target = this.state.schedule.find((d) => d.shifts.length > 0 && DateUtility.parse(d.date) >= today);
        if (!target)
            return;
        window.requestAnimationFrame(() => {
            var _a;
            (_a = document.getElementById(`bi-vp-day-${target.date}`)) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ block: "start" });
        });
    }
    // Forrige (-1) and Næste (1), from the buttons or a swipe. The week on screen slides out
    // while the next one is fetched, and that one slides in from the other side. One step at a
    // time: a second swipe before the first has landed is dropped.
    addWeek(inc) {
        if (this.navigating || !this.state.isLoaded)
            return;
        this.navigating = true;
        const week = this.state.week.plus({ days: inc * 7 });
        const swipe = this.swipeRef.current;
        const slidOut = swipe.slideOut(inc);
        Promise.all([this.fetchSchedule(week), slidOut])
            .then(([loaded]) => new Promise((resolve) => {
            this.showWeekInUrl(week);
            this.setState(loaded, () => resolve(swipe.slideIn(inc)));
        }))
            .catch((error) => {
            // The week that slid out is still the one to show, so it comes back the way it went.
            console.error(error);
            return slidOut.then(() => swipe.slideIn(-inc));
        })
            .finally(() => { this.navigating = false; });
    }
    showDay(date) {
        var _a;
        (_a = document.getElementById(`bi-vp-day-${date}`)) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: scrollBehavior(), block: "start" });
    }
    renderHead(now) {
        const week = this.state.week;
        const today = now.startOf("day");
        return (React.createElement("div", { className: "bi-vp-head" },
            React.createElement("div", { className: "bi-vp-bar" },
                React.createElement("div", { className: "bi-vp-title" },
                    React.createElement("h1", null, "Vagtplan"),
                    React.createElement("span", { className: "bi-vp-when" },
                        React.createElement("span", { className: "bi-vp-range" },
                            React.createElement("span", { className: "d-lg-none" }, DateUtility.weekRange(week)),
                            React.createElement("span", { className: "d-none d-lg-inline" }, DateUtility.weekRange(week, true))),
                        week.plus({ days: 7 }) <= today
                            ? React.createElement("span", { className: "bi-chip bi-chip-past-week" },
                                React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true" },
                                    React.createElement("circle", { cx: "12", cy: "12", r: "9" }),
                                    React.createElement("path", { d: "M12 7v5l3 2" })),
                                "Tidligere")
                            : null)),
                React.createElement("div", { className: "bi-vp-nav" },
                    React.createElement("button", { type: "button", className: "bi-vp-step", "aria-label": "Forrige uge", onClick: () => this.addWeek(-1) },
                        React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true" },
                            React.createElement("path", { d: "m15 6-6 6 6 6" }))),
                    React.createElement("span", { className: "d-lg-none" },
                        React.createElement(WeekPicker, { week: week, onSelect: this.selectWeek })),
                    React.createElement("span", { className: "d-none d-lg-inline" },
                        React.createElement(WeekPicker, { week: week, wide: true, onSelect: this.selectWeek })),
                    React.createElement("button", { type: "button", className: "bi-vp-step", "aria-label": "N\u00E6ste uge", onClick: () => this.addWeek(1) },
                        React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true" },
                            React.createElement("path", { d: "m9 6 6 6-6 6" }))))),
            React.createElement("div", { className: "bi-seg bi-vp-seg", role: "group", "aria-label": "Vis vagter" },
                React.createElement("button", { type: "button", "aria-pressed": !this.state.mineOnly, onClick: () => this.setState({ mineOnly: false }) }, "Alle vagter"),
                React.createElement("button", { type: "button", "aria-pressed": this.state.mineOnly, onClick: () => this.setState({ mineOnly: true }) }, "Mine vagter")),
            React.createElement("div", { className: "bi-vp-strip" }, this.shownDays().map((day) => {
                const dt = DateUtility.parse(day.date);
                const isToday = dt.hasSame(today, "day");
                const has = day.shifts.length > 0;
                return (React.createElement("button", { type: "button", key: day.date, disabled: !has, className: `bi-vp-strip-day${isToday ? " bi-vp-strip-today" : ""}${has ? " bi-vp-strip-has" : ""}`, "aria-label": `${DateUtility.longDay(dt)}${has ? `, ${day.shifts.length} ${day.shifts.length === 1 ? "vagt" : "vagter"}` : ", ingen vagter"}`, onClick: () => this.showDay(day.date) },
                    React.createElement("span", { className: "bi-vp-strip-name" }, DateUtility.weekdayCaps(dt)),
                    React.createElement("span", { className: "bi-vp-strip-num" }, dt.day),
                    React.createElement("span", { className: `bi-vp-strip-dot${has ? ` bi-vp-strip-dot-${dayDot(day.shifts, now)}` : ""}` })));
            }))));
    }
    /** The days of the week with the shifts the filter lets through. */
    shownDays() {
        var _a;
        const days = (_a = this.state.schedule) !== null && _a !== void 0 ? _a : [];
        if (!this.state.mineOnly)
            return days;
        return days.map((day) => (Object.assign(Object.assign({}, day), { shifts: day.shifts.filter((s) => { var _a; return ((_a = s.members) !== null && _a !== void 0 ? _a : []).some((m) => m.memberId === this.props.memberudi); }) })));
    }
    render() {
        if (!this.state.isLoaded && this.state.firstLoad) {
            return (React.createElement("div", { className: "bp-loading" },
                React.createElement("i", { className: "fa fa-spinner fa-pulse fa-fw" })));
        }
        const now = DateTime.now();
        const today = now.startOf("day");
        const days = this.shownDays();
        const none = days.every((d) => d.shifts.length === 0);
        return (React.createElement("div", { className: "bi-vp" },
            this.renderHead(now),
            React.createElement(SwipeNavigation, { ref: this.swipeRef, onPrevious: () => this.addWeek(-1), onNext: () => this.addWeek(1) },
                React.createElement("div", { className: "bi-vp-body" },
                    none
                        ? React.createElement("p", { className: "bi-vp-none" }, this.state.mineOnly ? "Du har ingen vagter i denne uge." : "Der er ingen vagter i denne uge.")
                        : null,
                    React.createElement("div", { className: "bi-vp-scroll" },
                        React.createElement("div", { className: "bi-vp-grid" }, days.map((day) => {
                            const dt = DateUtility.parse(day.date);
                            const isToday = dt.hasSame(today, "day");
                            const has = day.shifts.length > 0;
                            return (React.createElement("section", { key: day.date, id: `bi-vp-day-${day.date}`, className: `bi-vp-day${isToday ? " bi-vp-day-today" : ""}${dt < today ? " bi-vp-day-past" : ""}${has ? "" : " bi-vp-day-empty"}` },
                                React.createElement("h2", { className: "bi-vp-day-head" },
                                    React.createElement("span", { className: "bi-vp-day-long" }, DateUtility.longDay(dt)),
                                    React.createElement("span", { className: "bi-vp-day-short", "aria-hidden": "true" },
                                        React.createElement("span", { className: "bi-vp-day-name" }, DateUtility.weekdayCaps(dt)),
                                        React.createElement("span", { className: "bi-vp-day-num" }, dt.day))),
                                has
                                    ? day.shifts.map((shift) => (React.createElement(ShiftCard, { key: shift.id, shift: shift, memberUdi: this.props.memberudi, now: now })))
                                    : React.createElement("p", { className: "bi-vp-day-none" }, "Ingen vagter")));
                        })))))));
    }
}
ReactRenderer.render("fullschedulecomponent", (elem) => React.createElement(FullScheduleComponent, Object.assign({}, (elem.dataset))));
